/**
 * @desc 更新钉钉待办任务状态
 */

import { RequestConfig, request } from 'umi';

function req(
  data: defs.store.UpdateDingTalkWorkStateRequestDTO,
  config: Parameters<typeof request>[1] = {},
) {
  return request<defs.store.HttpResponse>(
    `/storeapi/api/v1/store/feedback/dingtalk-work/state`,
    {
      data,
      method: 'put',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
